export default "__VITE_ASSET__DCrZ_0y1__"